// region 模块展示配置

export type HealthPlanModule =
  | 'diet'
  | 'exercise'
  | 'nutrition'
  | 'tcm'
  | 'monitoring'
  | 'review'
  | 'medication'
  | 'recommendation';

export type HealthPlanModuleTone = 'blue' | 'green' | 'purple' | 'orange';

export const healthPlanModuleMeta: Record<
  HealthPlanModule,
  { title: string; tone: HealthPlanModuleTone }
> = {
  diet: { title: '饮食方案', tone: 'blue' },
  exercise: { title: '运动处方', tone: 'green' },
  nutrition: { title: '营养方案', tone: 'purple' },
  tcm: { title: '中医调理', tone: 'purple' },
  monitoring: { title: '监测随访', tone: 'orange' },
  review: { title: '复查提醒', tone: 'orange' },
  medication: { title: '用药管理', tone: 'blue' },
  recommendation: { title: '推荐产品', tone: 'green' },
};

export function healthPlanModuleToneClass(tone: HealthPlanModuleTone) {
  const toneMap: Record<HealthPlanModuleTone, string> = {
    blue: 'bg-warning-soft text-accent',
    green: 'bg-warning-soft text-success',
    purple: 'bg-warning-soft text-accent',
    orange: 'bg-warning-soft text-warning',
  };
  return toneMap[tone];
}

// endregion

// region 模块图标

export function HealthPlanModuleIcon({ module }: { module: HealthPlanModule }) {
  switch (module) {
    case 'diet':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M7 4v16M4.5 4v5.5A2.5 2.5 0 0 0 7 12a2.5 2.5 0 0 0 2.5-2.5V4M16.5 4c2 1.5 3 3.4 3 5.8 0 2.2-.9 3.8-2.5 4.7V20"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'exercise':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M8.5 7.5c0 1.9-1.1 3.5-2.5 3.5S3.5 9.4 3.5 7.5 4.6 4 6 4s2.5 1.6 2.5 3.5ZM20.5 10.5c0 1.9-1.1 3.5-2.5 3.5s-2.5-1.6-2.5-3.5S16.6 7 18 7s2.5 1.6 2.5 3.5ZM12.5 16.5c0 1.9-1.1 3.5-2.5 3.5s-2.5-1.6-2.5-3.5S8.6 13 10 13s2.5 1.6 2.5 3.5Z"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      );
    case 'nutrition':
    case 'tcm':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M5 18c8 0 13-5 14-13-8 .5-13 4.5-13 10 0 2.8 2.2 5 5 5 2.7 0 5-1.5 6.5-4M5 20c2.5-4.5 5.5-7.5 9.5-9"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'monitoring':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M3 12h4l2-6 4 12 2.5-6H21"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'review':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Zm3 8h3v3H8v-3Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'medication':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.5 20.5 20.5 10.5a4.2 4.2 0 0 0-6-6L4.5 14.5a4.2 4.2 0 0 0 6 6ZM9 10l5 5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'recommendation':
      return (
        <svg
          aria-hidden="true"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            d="M5 8.5h14l-1 11H6l-1-11ZM9 9V7a3 3 0 0 1 6 0v2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
  }
}

// endregion
